import {View, Text, Modal, TouchableOpacity} from 'react-native';
import React from 'react';
import Feather from 'react-native-vector-icons/Feather';
import {Colors} from '../../../../constants/Colors';

import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';
import {useNavigation} from '@react-navigation/native';
import { AppRoutes } from '../../../../navigation/Routes.types';

interface IPendingDebtModal {
  visible: boolean;
  onRequestClose: () => void;
}

const PendingDebtModal = ({visible, onRequestClose}: IPendingDebtModal) => {
  const {navigate} = useNavigation();

  const handleDebtsPress = () => {
    onRequestClose();
    navigate(AppRoutes.DEBTS);
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View style={styles.containerModal}>
        <View style={styles.containerFilter}>
          <View style={styles.spaceHorizontal}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
          </View>

          <Feather
            name="alert-circle"
            size={48}
            color="#E53935"
            style={{alignSelf: 'center', marginTop: 10}}
          />

          <Text
            style={{
              fontSize: 20,
              lineHeight: 26,
              color: 'black',
              textAlign: 'center',
              maxWidth: 300,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 20,
            }}>
            Débito em aberto
          </Text>

          <Text
            style={{
              fontSize: 16,
              lineHeight: 22,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 280,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 24,
            }}>
            Notamos que você possui um débito em aberto há mais de 15 dias.
          </Text>

          <Text
            style={{
              fontSize: 16,
              lineHeight: 22,
              color: '#818181',
              textAlign: 'center',
              maxWidth: 280,
              alignSelf: 'center',
              fontFamily: 'TCCC-UnityText Bold',
              marginTop: 16,
            }}>
            É necessário efetuar o pagamento para continuar realizando novas
            compras.
          </Text>

          <View style={styles.containerButton}>
            <ButtonComponent
              title="Meus débitos"
              outlined
              width="48%"
              onPress={handleDebtsPress}
            />
            <ButtonComponent
              title="Entendi"
              width="48%"
              onPress={onRequestClose}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default PendingDebtModal;
